import { Column, CreateDateColumn, DeleteDateColumn, PrimaryGeneratedColumn } from 'typeorm';

export class ProdutoBase {
  @PrimaryGeneratedColumn()
  id!: number;

  @Column()
  nome: string = '';

  @Column()
  descricao: string = '';

  @Column({ default: false })
  permitePizzaDoisSabores: boolean = false;

  @CreateDateColumn({ select: false })
  createdAt!: Date;

  @DeleteDateColumn({ select: false })
  deletedAt!: Date;
}

export function criarProdutoBase(produto: ProdutoBase) {
  const produtoBase = new ProdutoBase();
  produtoBase.nome = produto.nome;
  produtoBase.descricao = produto.descricao;
  produtoBase.permitePizzaDoisSabores = produto.permitePizzaDoisSabores;
  // produtoBase.preco = produto.preco;
  return produtoBase;
}

export default ProdutoBase;
